import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class ObservableService {

    public knowMoreEmit$ = new Subject<boolean>();
    public resetTrxSwipe$ = new Subject<string>();
    public greenifyToggle$ = new Subject<string>();
    public checkMobileAppConfig$ = new Subject<boolean>();
    public showExceedLimitPopup$ = new BehaviorSubject<any>(null);
    public tabSelect$ = new Subject<any>();

    public resetTaskSwipe$ = new Subject<string>();
    public resetGoalSwipe$ = new Subject<string>();
    public resetBeneSwipe$ = new Subject<string>();
    public resetTransferSwipe$ = new Subject<string>();

    constructor() { }

    triggerKnowMore(val){
        this.knowMoreEmit$.next(val)
    }

    triggerTrxSwipe(val){
        this.resetTrxSwipe$.next(val)
    }
    
    getTriggerTrxSwipe(): Observable<any>{
        return this.resetTrxSwipe$.asObservable()
    }

    setExceedPopUp(val){
        this.showExceedLimitPopup$.next(val)
    }

    getExceedPopUp(): Observable<any>{
        return this.showExceedLimitPopup$.asObservable()
    }

    triggerGreenifyToggle(val){
        this.greenifyToggle$.next(val)
    }

    getGreenifyToggle(): Observable<any>{
        return this.greenifyToggle$.asObservable()
    }

    checkAppConfig(){
        return this.checkMobileAppConfig$.next(true);
    }
    getMobileAppConfig(){
        return this.checkMobileAppConfig$.asObservable();
    }

    triggerTabSelect(data){
        return this.tabSelect$.next(data);
    }

    /* Reset task list item swipe */
    triggerTaskSwipe(val){
        this.resetTaskSwipe$.next(val);
    }
    getTaskSwipeTrigger():Observable<any>{
        return this.resetTaskSwipe$.asObservable();
    }

    /* Reset goal list item swipe */
    triggerGoalSwipe(val){
        this.resetGoalSwipe$.next(val);
    }
    getGoalSwipeTrigger():Observable<any>{
        return this.resetGoalSwipe$.asObservable();
    }
    
    /* Reset bene list item swipe */
    triggerBeneSwipe(val){
        this.resetBeneSwipe$.next(val);
    }
    getBeneSwipeTrigger():Observable<any>{
        return this.resetBeneSwipe$.asObservable();
    }

    /**
     * Transfers list item swipe
     * @param val 
     */
    triggerTransferSwipe(val){
        this.resetTransferSwipe$.next(val);
    }
    getTransferSwipeTrigger():Observable<any>{
        return this.resetTransferSwipe$.asObservable();
    }
}